<template>
  <div>
    <!-- 头部 -->

    <!-- 搜索筛选 -->
    <el-form :inline="true" :model="formInline" class="user-search">
      <el-form-item label="搜索：">
        <el-input size="small" v-model="formInline.Name" placeholder="请输入车辆名称"></el-input>
      </el-form-item>
      <el-form-item>
        <el-button size="small" type="primary" icon="el-icon-search" @click="search">搜索</el-button>
        <el-button size="small" type="primary" icon="el-icon-plus" @click="handleAdd()">增加线路</el-button>
      </el-form-item>
    </el-form>
    <!--列表-->
    <el-table class="elTable" size="small" :data="listData" highlight-current-row v-loading="loading" border
      element-loading-text="拼命加载中" style="width: 100%;">
      <el-table-column align="center" prop="ID" label="ID" width="80"></el-table-column>

      <el-table-column align="center" prop="Name" label="线路名称" width="250"></el-table-column>
      <el-table-column align="center" prop="_map" label="所属地图" width="250"></el-table-column>
      <el-table-column align="center" prop="line_No" label="线路编号" width="250"></el-table-column>
      <el-table-column align="center" prop="editTime" label="加入时间" width="250">
        <template slot-scope="scope">
          <div>{{scope.row.editTime|timestampToTime}}</div>
        </template>
      </el-table-column>
      <el-table-column align="center" prop="note" label="备注" width="250"></el-table-column>
      <el-table-column align="center" fixed="right" label="操作" min-width="250">
        <template slot-scope="scope">
          <el-button size="mini" round>详情</el-button>
          <el-button size="mini" @click="handleEdit(scope.$index, scope.row)" round>编辑</el-button>
          <el-button size="mini" type="danger" @click="deleteUser(scope.$index, scope.row)" round>删除</el-button>
        </template>
      </el-table-column>
    </el-table>
    <!-- 分页组件 -->
    <Pagination v-bind:child-msg="pageparm" @callFather="callFather"></Pagination>
    <!-- 添加+ -->
        <el-dialog title="添加" :visible.sync="addFormVisible" width="50%" @click="closeDialog">
            <el-form :inline="true" :model="formInlines" class="user-search">
      <el-form-item label="搜索：">
        <el-input size="small" v-model="formInlines.line_name" placeholder="请输入车辆ID"></el-input>
      </el-form-item>
      <el-form-item >
        <el-input size="small" v-model="formInlines.line_map" placeholder="请输入所属地图"></el-input>
      </el-form-item>
   
      <el-form-item>
        <el-button size="small" type="primary" icon="el-icon-search" @click="search">搜索</el-button>
        <el-button size="small" type="primary" icon="el-icon-plus" @click="handleAdd()">增加线路</el-button>
      </el-form-item>
    </el-form>
       <el-table class="elTable" :data="listDatas" highlight-current-row 
      element-loading-text="拼命加载中" style="width: 100%;">
    <el-table-column
      type="selection"
      width="55">
    </el-table-column>
      <el-table-column align="center" prop="ID" label="ID" width="80"></el-table-column>

      <el-table-column align="center" prop="Name" label="线路名称" width="250"></el-table-column>
      <el-table-column align="center" prop="_map" label="所属地图" width="250"></el-table-column>
      <el-table-column align="center" prop="line_No" label="线路编号" width="250"></el-table-column>
      <el-table-column align="center" prop="editTime" label="加入时间" width="250">
        <template slot-scope="scope">
          <div>{{scope.row.editTime|timestampToTime}}</div>
        </template>
      </el-table-column>
      <el-table-column align="center" prop="note" label="备注" width="250"></el-table-column>
      
    </el-table>
        <span slot="footer" class="dialog-footer">
          <el-button @click="closeDialog('addForm')">取 消</el-button>
          <el-button type="primary" @click="closeDialog('addForm')">确 定</el-button>
        </span>
    </el-dialog>
    <!-- 编辑界面 -->
    <el-dialog title="编辑" :visible.sync="editFormVisible" width="30%" @click="closeDialog">
      <el-form style="padding-right:9%" label-width="120px" :model="editForm" :rules="rules" ref="editForm">
        <el-form-item label="线路名称" prop="Name">
          <el-input size="small" v-model="editForm.Name" auto-complete="off" placeholder="请输入线路名称"></el-input>
        </el-form-item>
        <el-form-item label="所属地图" prop="_map">
          <el-input size="small" v-model="editForm._map" auto-complete="off" placeholder="请输入所属地图"></el-input>
        </el-form-item>
        <el-form-item label="线路编号" prop="line_No">
          <el-input size="small" v-model="editForm.line_No" auto-complete="off" placeholder="请输入线路编号"></el-input>
        </el-form-item>

        <el-form-item label="加入时间" required>
          <el-col :span="11">
            <el-form-item prop="date1">
              <el-date-picker type="date" placeholder="选择日期" v-model="editForm.date1" style="width: 100%;">
              </el-date-picker>
            </el-form-item>
          </el-col>
          <el-col class="line" :span="2">-</el-col>
          <el-col :span="11">
            <el-form-item prop="date2">
              <el-time-picker placeholder="选择时间" v-model="editForm.date2" style="width: 100%;"></el-time-picker>
            </el-form-item>
          </el-col>
        </el-form-item>

        <el-form-item label="备注" prop="type">
          <el-input type="textarea" size="small" v-model="editForm.type" auto-complete="off" placeholder="请输入备注">
          </el-input>
        </el-form-item>
      </el-form>
        <span slot="footer" class="dialog-footer">
          <el-button @click="closeDialog('addForm')">取 消</el-button>
          <el-button type="primary" @click="closeDialog('addForm')">确 定</el-button>
        </span>
    </el-dialog>
  </div>
</template>

<script>

  import Pagination from "../../components/Pagination";
  export default {
    name: "areaLine",
    data() {
      return {
        activeName: "first",
        nshow: true, //switch开启
        fshow: false, //switch关闭
        loading: false, //是显示加载
        editFormVisible: false, //控制编辑页面显示与隐藏
        addFormVisible:false,

        editForm: {
          ID: "",
          Name: "",
          line_No: "",
          _map: "",
          note: "",
          date1: "",
          date2: "",
          token: localStorage.getItem("logintoken")
        },
        formInlines:{
          line_id:"",
          line_map:"",
        },
        // rules表单验证
        rules: {
          Name: [{ required: true, message: "请输入线路名称", trigger: "blur" }],
          _map: [{ required: true, message: "请输入所属地图", trigger: "blur" }],
          line_No: [
            { required: true, message: "请输入线路编号", trigger: "blur" }
          ],
          date1: [
            {
              type: "date",
              required: true,
              message: "请选择日期",
              trigger: "change"
            }
          ],
          date2: [
            {
              type: "date",
              required: true,
              message: "请选择时间",
              trigger: "change"
            }
          ]
        },
        formInline: {
          page: 1,
          limit: 10,
          varLable: "",
          varName: "",
          token: localStorage.getItem("logintoken")
        },
        // 删除部门
        seletedata: {
          ids: "",
          token: localStorage.getItem("logintoken")
        },
        userparm: [], //搜索权限
        listData: [], //用户数据
        listDatas:[],
        // 分页参数
        pageparm: {
          currentPage: 1,
          pageSize: 10,
          total: 10
        }
      };
    },

    // 注册组件
    components: {
      Pagination
    },
    /**
     * 创建完毕
     */
    created() {
      this.getdata(this.formInline);
    },
    methods: {
      handleClick(tab, event) {
        console.log(tab, event);
      },

      // 获取公司列表
      getdata(parameter) {
        this.loading = true;
        // 模拟数据开始
        let res = {
          code: 0,
          msg: null,
          count: 5,
          data: [
            {
              ID: 1005,
              Name: "测试测试",
              line_No: "测试测试",
              _map: "测试测试",
              addTime: 1526453107000,
              editTime: 1526453107000,
              note: "测试测试",
              parentId: 1
            },
            {
              ID: 1005,
              Name: "测试测试",
              line_No: "测试测试",
              _map: "测试测试",
              addTime: 1526453107000,
              editTime: 1526453107000,
              note: "测试测试",
              parentId: 1
            },
            {
              ID: 1005,
              Name: "测试测试",
              line_No: "测试测试",
              _map: "测试测试",
              addTime: 1526453107000,
              editTime: 1526453107000,
              note: "测试测试",
              parentId: 1
            }
          ]
        };
        this.loading = false;
        this.listData = res.data;
        this.pageparm.currentPage = this.formInline.page;
        this.pageparm.pageSize = this.formInline.limit;
        this.pageparm.total = res.count;
        // 模拟数据结束

        /***
         * 调用接口，注释上面模拟数据 取消下面注释
         */
       
      },
      // 分页插件事件
      callFather(parm) {
        this.formInline.page = parm.currentPage;
        this.formInline.limit = parm.pageSize;
        this.getdata(this.formInline);
      },
      // 搜索事件
      search() {
        this.getdata(this.formInline);
      },
      handleAdd(){
        this.addFormVisible = true;
      },
      //显示编辑界面
      handleEdit: function (index, row) {
        this.editFormVisible = true;
        if (row != undefined && row != "undefined") {
          this.title = "修改";
          this.editForm.deptId = row.deptId;
          this.editForm.deptName = row.deptName;
          this.editForm.deptNo = row.deptNo;
        } else {

          this.editForm.deptId = "";
          this.editForm.deptName = "";
          this.editForm.deptNo = "";
        }
      },
      // 编辑、增加页面保存方法
   
      // 删除公司
  
      // 关闭编辑、增加弹出框
      closeDialog() {
        this.editFormVisible = false;
        this.addFormVisible = false;
      }
    }
  };
</script>
<style scoped>
  .head {
    width: 99%;
    padding-bottom: 1%;
    margin-top: 1%;
    margin-left: 1%;
    font-size: 20px;
    color: #334157;
    border-bottom: 1px solid #f5f5f5;
  }

  el-tabs {
    margin-left: 1%;
  }

  .user-search {
    margin-top: 20px;
  }

  .userRole {
    width: 100%;
  }

  .elTable /deep/ td {
    padding: 0.5% 0 !important;
  }
</style>


// WEBPACK FOOTER //
// src/views/area_mn/line.vue